import React from 'react';
import {X6Page} from '../../../domain';
import {TooltipBreadcrumb} from '../../../lib/components';
import {routes} from '../../../pages/Routes';

export class X6PageBreadcrumbs extends React.Component<{ page: X6Page }> {
  render() {
    const {page} = this.props;
    return (
      <div className="row">
        <div className="col">
          <div className="breadcrumb">
            <TooltipBreadcrumb tooltip="Languages"
                               label="Languages"
                               route={routes.X1LanguageList}/>

            <TooltipBreadcrumb tooltip="Language"
                               label={page!.Lesson!.Unit!.Level!.AgeCategory!.Language!.Name}
                               route={routes.x1language(page!.Lesson!.Unit!.Level!.AgeCategory!.LanguageId)}/>

            <TooltipBreadcrumb tooltip="Age Category"
                               label={page!.Lesson!.Unit!.Level!.AgeCategory!.Name}
                               route={routes.x2ageCategory(page!.Lesson!.Unit!.Level!.AgeCategoryId)}/>

            <TooltipBreadcrumb tooltip="Level"
                               label={page!.Lesson!.Unit!.Level!.Name}
                               route={routes.x3level(page!.Lesson!.Unit!.LevelId)}/>

            <TooltipBreadcrumb tooltip="Unit"
                               label={page!.Lesson!.Unit!.Name}
                               route={routes.x4unit(page!.Lesson!.UnitId)}/>

            <TooltipBreadcrumb tooltip="Lesson"
                               label={page!.Lesson!.Name}
                               route={routes.x5lesson(page!.LessonId)}/>

            <TooltipBreadcrumb tooltip="Page"
                               label={page!.Name}
                               active/>
          </div>
        </div>
      </div>
    );
  }
}
